<app-subject-topic-header head="Information &amp; Support"></app-subject-topic-header>

<ul>
  <li><a [routerLink]="['./homescreen']">Adding Exam Coach to Your Device's Homescreen</a></li>
  <li><a [routerLink]="['./faq']">Frequently Asked Questions</a></li>
  <li><a [routerLink]="['./sources']">Sources</a></li>
  <li><a [routerLink]="['./contacts']">Contact Us</a></li>
</ul>
